import {
  FrequencyUnit,
  PlannedOccurrence,
  ScheduleEntryState,
  Timestamp,
} from '@griply/types';

export type UpcomingPeriodDay = {
  date: Timestamp;
  entry?: DayEntry;
};
export enum UpcomingPeriodTypes {
  Overdue = 'overdue',
}

export type UpcomingPeriod = {
  date: Timestamp;
  days: UpcomingPeriodDay[];
  type: FrequencyUnit | UpcomingPeriodTypes;
};

export type DayEntry = PlannedOccurrence & {
  isGeneratedFrequencyEntry: boolean;
  isUnplannedEntry: boolean;
  state?: ScheduleEntryState;
  hidden?: boolean;
};
